import { useState } from "react"

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog.tsx"

import DataPointTable from "../DataPointTable.tsx"

export default function DataPointSelector({
  onSelect,
  children,
}: {
  onSelect: (id: number) => void
  children: React.ReactNode
}) {
  const [open, setOpen] = useState<boolean>(false)
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[800px] h-4/5 justify-baseline flex flex-col">
        <DialogHeader className="grow-0 shrink">
          <DialogTitle>Select Data Point</DialogTitle>
        </DialogHeader>
        <div className="max-h-full overflow-y-hidden grow h-full">
          <DataPointTable
            variant="selector"
            onSelect={(id) => {
              setOpen(false)
              onSelect(id)
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
